






























import Vue from 'vue';

interface IAmountStepperComponent {
  amount: number;
}

export default Vue.extend({
  name: `AmountStepper`,
  data(): IAmountStepperComponent {
    return {
      amount: 1,
    };
  },
  props: {
    maxAmount: {
      required: true,
      type: Number,
    },
  },
  methods: {
    decreaseAmount(): void {
      this.amount--;
      this.$emit(`update:amount`, this.amount);
    },
    increaseAmount(): void {
      this.amount++;
      this.$emit(`update:amount`, this.amount);
    },
    validateInput(): void {
      if(this.amount < 1 || this.amount > this.maxAmount) {
        this.amount = this.amount < 1 ? 1 : this.maxAmount;
      }
      this.$emit(`update:amount`, +this.amount);
    },
  },
});
